import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import Header from "../components/comunes/Header";
import Footer from "../components/comunes/Footer";

import { getLocalStorage, setLocalStorage } from "../utils/localStorage";

const MfaLogin = (props) => {
  const [mfaCode, setMfaCode] = useState("");
  const [email, setEmail] = useState("");
  const [user, setUser] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const [timeLeft, setTimeLeft] = useState(300); // Timer de 60 segundos
  const [errorMessage, setErrorMessage] = useState(""); // Mensaje de error
  const maxAttempts = 2;
  let history = useHistory();

  useEffect(() => {
    sendCode();
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // Limpiar el temporizador
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      alert("El tiempo ha expirado. Por favor, inicia sesión nuevamente.");
      handleSignOut();
    }
  }, [timeLeft]);

  const sendCode = async () => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      const response = await Auth.signIn(currentUser.username);
      console.log("response", response);
      setEmail(response.challengeParam ? response.challengeParam.email : "");
      setUser(response);
    } catch (error) {
      console.error("Error al enviar el código:", error);
    }
  };

  const handleMfaSubmit = async (event) => {
    event.preventDefault();
    try {
      setErrorMessage(""); // Limpiar mensaje de error al intentar de nuevo
      const clientMetadata = {
        auth: "mfa_challenge",
      };
      const resp = await Auth.sendCustomChallengeAnswer(
        user,
        mfaCode,
        clientMetadata
      );
      let location = getLocalStorage("location-search");
      let flujo = location.replace("?flujo=", "");
      setLocalStorage("FLUJO", flujo);
      setLocalStorage("mfaLogin", true);
      history.push({ pathname: flujo.replace("#", "/") });
    } catch (error) {
      alert("El código es incorrecto. Intenta nuevamente.");
      handleSignOut();
    }
  };

  const handleSignOut = async () => {
    await Auth.signOut();
    history.push({ pathname: "/login" });
  };


  const mask = (email) => {
    if (email.includes("@")) {
      let mailArray = email.split("@");
      return mailArray[0].slice(0, 2) + "****" + "@" + mailArray[1]
    }
    return ""
  }

  return (
    <>
      <Header />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <form
          onSubmit={handleMfaSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "300px",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h5 style={{ marginBottom: "20px" }}>Ingresa tu código</h5>
          <p>
            Por favor revisa tu buzón de correo electrónico {mask(email)} e
            ingresa el código para acceder
          </p>
          <input
            type="text"
            placeholder="Código de verificación"
            onChange={(e) => setMfaCode(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "15px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
          {errorMessage && (
            <label style={{ color: "red", marginBottom: "15px" }}>
              {errorMessage}
            </label>
          )}
          <p>Tiempo restante: {timeLeft} segundos</p>
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              backgroundColor: "#ef3340",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            Ingresar
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default MfaLogin;
